import { render, staticRenderFns } from "./daxqYz.vue?vue&type=template&id=22388fc8&scoped=true&"
import script from "./daxqYz.vue?vue&type=script&lang=js&"
export * from "./daxqYz.vue?vue&type=script&lang=js&"
import style0 from "./daxqYz.vue?vue&type=style&index=0&id=22388fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22388fc8",
  null
  
)

export default component.exports